import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`

* {
  padding: 0px;
  margin: 0px;
  font-family: "regular", sans-serif;
  font-size: ${({ theme }) => theme.font.size.md};
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    font-size: ${({ theme }) => theme.font.size.sm};
  }
}

html,
body {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  scroll-behavior: smooth;
}

.Toastify {
  * {
  font-size: ${({ theme }) => theme.font.size.sm};
  }
}

input {
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${({ theme }) => theme.color.font.primary};
    opacity: 1; /* Firefox */
    font-family: 'thin';
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${({ theme }) => theme.color.font.primary};
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${({ theme }) => theme.color.font.primary};
  }
}

.tooltip {
  --tooltip-offset: calc(100% + var(--tooltip-tail, 0px))
}

.btn-primary {
  background-color: ${({ theme }) => theme.color.background.primary};
  border-color: ${({ theme }) => theme.color.background.primary};
  color: ${({ theme }) => theme.color.font.secondary};
  font-size: ${({ theme }) => theme.font.size.md};
  outline: none;
  &:hover {
    background-color: ${({ theme }) => theme.color.background.secondary};
    border-color: ${({ theme }) => theme.color.background.secondary};
  }
}

.btn-primary-outline {
  background-color: ${({ theme }) => theme.color.font.secondary};
  border-color: ${({ theme }) => theme.color.background.primary};
  color: ${({ theme }) => theme.color.background.primary};
  font-size: ${({ theme }) => theme.font.size.md};
  outline: none;
  &:hover {
    background-color: ${({ theme }) => theme.color.background.primary};
    border-color: ${({ theme }) => theme.color.background.primary};
    color: ${({ theme }) => theme.color.font.secondary};
  }
}
`

export default GlobalStyles
